const types = {
    SET_LIST_FREESPIN: '[FREESPIN] SET LIST FREESPIN'
}

export {
    types
}